import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failedApproaches = ['Las "plantillas de CV" de internet son rechazadas automáticamente por los filtros de Inteligencia Artificial (ATS).', 'Los consejos de "ser positivo" no pagan el alquiler ni la hipoteca a fin de mes.', 'Esperar a que la empresa "sea justa" contigo es el error más caro que puedes cometer.', 'Buscar empleo sin un "pitch" de crisis te hace ver desesperado ante los reclutadores.'];
export function WhyItDidntWork() {
  return <section className="bg-off-white py-16 px-6" data-id="element-195">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-196">
        <h2 className="font-serif text-3xl md:text-4xl mb-12 text-center text-navy" data-id="element-197">
          Por Qué Lo Que Intentaste{' '}
          <span className="text-red-600" data-id="element-198">No Funcionó</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-199">
          {failedApproaches.map((approach, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-600" data-id="element-200">
              <div className="flex items-start gap-3" data-id="element-201">
                <XCircleIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-202" />
                <p className="text-gray-800" data-id="element-203">{approach}</p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}